import React, { useState, useCallback, useEffect } from "react";
import { MasterTable, AutoComplete, DatePicker } from "../../components/_index";
import {
    deleteHrAdminWork,
    getHrAdminWork,
} from "../../services/hrAndAdminWork.service";
import { Box, Button, Stack, Typography, Grid } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import AddHrAndAdminWork from "./AddHrAndAdminWork";
import HrAndAdminWorkHistory from "./HrAndAdminWorkHistory";
import { updateHrAdminWork } from "../../services/hrAndAdminWork.service";
import { getRole } from "../../services/category.service";
import { getUser, getHrAdminAccountsUsers } from "../../services/user.service";
import moment from "moment";

const HrAndAdminWork = () => {
    const [data, setData] = useState([]);
    const [tableTotalCount, setTableCount] = useState(0);
    const dispatch = useDispatch();
    const [queryParam, setQueryParam] = useState({
        search: "",
        page: 1,
        limit: 10,
        sortType: "",
        sort: "",
        departmentId: "",
        inchargeId: "",
        completedDate: "",
    });

    const [departmentData, setDepartmentData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedIncharge, setSelectedIncharge] = useState(null);
    const [selectedCompletedDate, setSelectedCompletedDate] = useState(null);

    const GetHrAdminWorkData = async () => {
        try {
            const res = await getHrAdminWork(queryParam);
            console.log(res, "Work Data");
            const modifiedData =
                res?.data.map((e) => ({
                    ...e,
                    targetDateToComplete: e.targetDateToComplete, // Preserve original date for edit form
                    formattedTargetDate: e.targetDateToComplete ? moment(e.targetDateToComplete).format("DD-MM-YYYY") : "-",
                    formattedCompletedDate: e.completedDate ? moment(e.completedDate).format("DD-MM-YYYY") : "-",
                })) || [];
            setTableCount(res?.totalCount || 0);
            setData(modifiedData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetHrAdminWorkData();
    }, [
        queryParam.search,
        queryParam.sort,
        queryParam.limit,
        queryParam.page,
        queryParam.departmentId,
        queryParam.inchargeId,
        queryParam.completedDate,
    ]);

    useEffect(() => {
        getDepartments();
        getUsers();
    }, []);

    const getDepartments = async () => {
        try {
            const res = await getRole({ isHrAdminWork: true });
            if (res?.data) {
                const modData = res.data.map(d => ({ ...d, label: d.name, id: d._id }));
                setDepartmentData(modData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getUsers = async () => {
        try {
            const res = await getHrAdminAccountsUsers();
            if (res?.data) {
                const modData = res.data.map(u => ({ ...u, label: u.name, id: u._id }));
                setUsersData(modData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const columns = [
        { id: "taskNo", label: "Task No" },
        { id: "task", label: "Task" },
        { id: "departmentName", label: "Department" },
        { id: "inchargeName", label: "Incharge" },
        { id: "formattedTargetDate", label: "Target Date" },
        // { id: "completedDate", label: "Completed Date" },
    ];

    const [openDrawer, setOpenDrawer] = useState(false);

    const [selectedData, setSelectedData] = useState({});
    const [openHistoryDrawer, setOpenHistoryDrawer] = useState(false);

    const tableOutputEvent = useCallback((params) => {
        setQueryParam((queryParams) => ({
            ...queryParams,
            ...params,
        }));
    }, []);

    const handleAdd = () => {
        setSelectedData({});
        setOpenDrawer(true);
    };
    const handleView = (e) => {
        setSelectedDataId(e._id);
        setOpenHistoryDrawer(true);
    };

    const handleEdit = (e) => {
        e.isView = false;
        setOpenDrawer(true);
        setSelectedData(e);
    };

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [selectedDataId, setSelectedDataId] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const handleToggleStatus = (e) => {
        setSelectedDataId(e._id);
        setSelectedRowData(e);
        setConfirmDeleteOpen(true);
    };

    const toggleStatusFunction = async () => {
        try {
            const isCurrentlyInactive = selectedRowData?.status === "3";
            const newStatus = isCurrentlyInactive ? "1" : "3"; // Toggle between active (1) and inactive (3)
            const message = isCurrentlyInactive
                ? "Work marked as active successfully"
                : "Work marked as inactive successfully";

            await updateHrAdminWork(selectedDataId, { status: newStatus });
            setConfirmDeleteOpen(false);
            GetHrAdminWorkData();
            dispatch(showToast({ message, type: "success" }));
        } catch (error) {
            console.log(error);
            dispatch(showToast({ message: "Failed to update status", type: "error" }));
        }
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const debouncedHandleSearch = useCallback(
        debounce((searchText) => {
            setQueryParam((queryParams) => ({
                ...queryParams,
                search: searchText,
            }));
        }, 300),
        []
    );

    const handleSearch = (searchText) => {
        debouncedHandleSearch(searchText);
    };

    return (
        <div className="mainContent">
            <Box sx={{ display: "flex", justifyContent: "space-between" }} mb={2}>
                <Box className="SearchInputBoxContainer">
                    <SearchOutlinedIcon className="Search_Icon" />
                    <input
                        className="SearchInputBox"
                        placeholder="Search here"
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </Box>

                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={2}
                >
                    <Stack sx={{ width: "200px" }}>
                        <AutoComplete
                            options={departmentData}
                            value={selectedDepartment}
                            getOptionLabel={(option) => option.label}
                            onChange={(e, v) => {
                                setSelectedDepartment(v);
                                setQueryParam(prev => ({ ...prev, departmentId: v?.id || "", page: 1 }));
                            }}
                            placeholder="Select Department"
                        />
                    </Stack>

                    <Stack sx={{ width: "200px" }}>
                        <AutoComplete
                            options={usersData}
                            value={selectedIncharge}
                            getOptionLabel={(option) => option.label}
                            onChange={(e, v) => {
                                setSelectedIncharge(v);
                                setQueryParam(prev => ({ ...prev, inchargeId: v?.id || "", page: 1 }));
                            }}
                            placeholder="Select Incharge"
                        />
                    </Stack>

                    {/* <Stack sx={{ width: "200px" }}>
                        <DatePicker
                            value={selectedCompletedDate}
                            onChange={(v) => {
                                setSelectedCompletedDate(v);
                                setQueryParam(prev => ({
                                    ...prev,
                                    completedDate: v ? moment(v).format("YYYY-MM-DD") : "",
                                    page: 1
                                }));
                            }}
                            placeholder="Completed Date"
                        />
                    </Stack> */}

                    <Button onClick={handleAdd} className="addButton">
                        <AddIcon />
                        Add Work
                    </Button>
                </Stack>
            </Box>
            <MasterTable
                data={data}
                columns={columns}
                isServerSide={true}
                isActionObject={true}
                isInactiveAction={true}
                handleView={handleView}
                handleEdit={handleEdit}
                handleDelete={handleToggleStatus}
                tableTotalCount={tableTotalCount}
                tableOutputEvent={tableOutputEvent}
            />
            {openDrawer ? (
                <AddHrAndAdminWork
                    open={openDrawer}
                    setOpenDrawer={setOpenDrawer}
                    selectedData={selectedData}
                    handleCloseDrawer={handleCloseDrawer}
                    formType={
                        selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
                    }
                    GetHrAdminWorkData={GetHrAdminWorkData}
                />
            ) : null}
            {openHistoryDrawer ? (
                <HrAndAdminWorkHistory
                    open={openHistoryDrawer}
                    handleClose={() => setOpenHistoryDrawer(false)}
                    workId={selectedDataId}
                />
            ) : null}
            <ConfirmBox
                open={confirmDeleteOpen}
                title={
                    selectedRowData?.status === "3"
                        ? "Are you sure you want to mark as active?"
                        : "Are you sure you want to mark as inactive?"
                }
                content={
                    selectedRowData?.status === "3"
                        ? "You are about to mark this item as active"
                        : "You are about to mark this item as inactive"
                }
                confirmButton={selectedRowData?.status === "3" ? "Make Active" : "Make Inactive"}
                setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
                Function={toggleStatusFunction}
            />
        </div>
    );
};

export default HrAndAdminWork;
